
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Heading', component.exports)
}
export default {
	props: {
		level: {
			type: String,
			required: true
		},
		clamp: {
			type: Boolean,
			default: true
		}
	},
	render: function(createElement) {
		return createElement(
			'h' + this.level, // tag name
			{
				class: 'heading',
				style: `--heading-clamp: ${this.clamp ? 'block' : 'none'}`
			},
			this.$slots.default // array of children
		);
	}
};
